import { ArrowRight } from "lucide-react";
import { CAPABILITIES } from "@/data/site";
import { Reveal } from "@/components/site/Reveal";
import Img from "@/components/site/Img";

export const Capabilities = () => (
  <section
    id="capabilities"
    data-testid="capabilities-section"
    className="relative bg-ivory pb-20 md:pb-28"
  >
    <div className="mx-auto max-w-shell px-6 md:px-10">
      <Reveal>
        <div className="label-xs text-slate">Capabilities</div>
        <div className="mt-6 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <h2 className="font-display font-normal text-obsidian leading-[1.12] tracking-[-0.015em] text-[clamp(1.6rem,3.1vw,2.6rem)] max-w-[20ch]">
            Solutions for every stage of the retail experience.
          </h2>
        </div>
      </Reveal>

      <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-5">
        {CAPABILITIES.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.06}>
            <article
              data-testid={`capability-${i}`}
              className="group relative frame h-[340px] lg:h-[380px] scrim-bottom"
            >
              <Img src={c.src} alt={c.alt} className="w-full h-full object-cover" />

              <div className="absolute inset-x-0 bottom-0 z-10 p-6">
                <h3 className="label text-ivory">{c.title}</h3>
                <div className="mt-3 space-y-1">
                  {c.lines.map((l) => (
                    <p key={l} className="text-[0.8rem] text-ivory/60 leading-snug">
                      {l}
                    </p>
                  ))}
                </div>
                <ArrowRight
                  size={15}
                  className="mt-5 text-champagne group-hover:translate-x-1.5 transition-transform duration-400"
                />
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Capabilities;
